/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const colDefs = [

    {
        field: 'code',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 298,
        cellRenderer: params => {

            if ( params.value !== '' ) {

                return ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.value}`}>{params.value}</Link> );

            }

            return ( <span>{params.value}</span> );

        }
    }
];

const PoolMachineMissingPkgCodeTable = props => (

    <section className="atp-search-result-panel pool-machine-missing-pkg-code-result-panel ">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

PoolMachineMissingPkgCodeTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default PoolMachineMissingPkgCodeTable;
